import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const hoeysRoutes = [
  {
    path: '/hoeys',
    name: Routes.Hoeys,
    component: () => import('@/pages/contexts/portal/hoeys/Index.vue'),
    meta: {
      pageTitle: 'Hoeys',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_HOEYS,
    },
    children: [
      {
        path: 'create',
        name: Routes.CreateHoey,
        component: () => import('@/pages/contexts/portal/hoeys/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.VIEW_HOEYS,
        },
      },
      {
        path: 'view/:hoeyId',
        name: Routes.ViewHoey,
        component: () => import('@/pages/contexts/portal/hoeys/View.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.VIEW_HOEYS,
        },
      },
    ],
  },
]
